<template>
  <div id="tickets">
    <div id="container">
      <div class="box shadow">
        <topdata v-bind:data="topData"></topdata>
      </div>

      <div class="column column-33 no-padding-left">
        <transition name="fade">
          <div class="box shadow" v-if="ticket.data.description">
            <h2>{{ $t('extra-info' )}}</h2>
            <p>{{ ticket.data.description }}</p>
          </div>
        </transition>

        <div class="box shadow">
          <h2>Interne notities</h2>

          <transition name="fade">
            <div class="internal-messages" v-show="ticket.loaded">
              <message v-for="(message, index) in ticket.data.internal_messages"
                       :message="message"
                       :key="index"></message>

              <div class="messages-wrapper">
                <div class="no-messages"
                     v-show="!hasMessages(ticket.data)">
                  {{ $t('no-internal-messages') }}
                </div>
              </div>

              <div class="new-message shadow">
                <form v-on:submit.prevent="sendNewInternalMessage">
                  <div class="attachment">
                    <label for="new-message-file"><i class="fal fa-paperclip clickable"></i></label>
                    <input id="new-message-file"
                           type="file"
                           multiple
                           ref="internalMessageFile"
                           v-on:change="handleFileUpload()">
                  </div><!--
                  --><div class="message-text">
                    <input type="text"
                           v-model="newInternalMessage.message"
                           placeholder="Typ een bericht...">
                  </div><!--
                  --><div class="send-button">
                    <button class="clickable">Verzenden</button>
                  </div>
                </form>
              </div>

              <transition name="fade">
                <div class="uploadedFiles" v-show="newInternalMessage.files.length > 0">
                  <h3>{{ $t('added-files') }}</h3>
                  <div class="uploadedFile"
                       v-for="(file, index) in newInternalMessage.files"
                       :key="index">
                    <i class="fal fa-file"></i> {{ file.name }}<br/><br/>
                  </div>
                </div>
              </transition>
            </div>
          </transition>

          <div class="loader" v-if="!ticket.loaded"></div>
        </div>
      </div><!--

      --><div class="column column-66 no-padding-right">
      <div class="box shadow">
        <h2>{{ $t('communication') }}</h2>

        <transition name="fade">
          <div class="content" v-show="ticket.loaded">
            <message v-for="(message, index) in ticket.data.communication"
                     :message="message"
                     :key="index"></message>

            <div class="no-messages"
                 v-if="!hasCommunication(ticket.data)">
              {{ $t('no-messages') }}
            </div>
          </div>
        </transition>

        <div class="loader" v-if="!ticket.loaded"></div>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import { Tickets } from '../../services/api/ApiRoutes';

export default {
  name: 'SingleTicket',

  data() {
    // Set page title
    this.$parent.title.heading = 'Ticket';
    this.$parent.title.subheading = '';

    return {
      topData: [],
      ticket: {
        error: null,
        data: [],
        loaded: false,
      },
      newInternalMessage: {
        message: '',
        files: [],
      },
    };
  },

  mounted() {
    this.getTicket(this.$route.params.id);
  },

  methods: {
    getTicket(id) {
      Tickets.getOne(id).then((ticket) => {
        this.ticket.error = null;
        this.ticket.data = ticket;

        this.$parent.title.subheading = ticket.title;
        this.updateTopData(ticket);

        this.ticket.loaded = true;
      }).catch((error) => {
        this.ticket.error = error;
        this.ticket.loaded = true;
      });
    },

    updateTopData(ticket) {
      this.topData = [
        {
          title: this.$t('company'),
          value: ticket.client.name,
          icon: 'fa-building',
          link: `/companies/${ticket.client._id}`,
        },
        {
          title: this.$t('contact'),
          value: ticket.client.name, // TODO change
          icon: 'fa-user',
          link: `/tickets/${ticket._id}`,
        },
        {
          title: this.$t('contact-moments'),
          value: ticket.communication.length,
          icon: 'fa-comments',
          link: `/tickets/${ticket._id}`,
        },
        {
          title: this.$t('created-at'),
          value: this.$moment(ticket.created_at).fromNow(),
          icon: 'fa-calendar',
          link: `/tickets/${ticket._id}`,
        },
        {
          title: this.$t('employee'),
          value: ticket.user.fullName || this.$t('none'),
          icon: 'fa-user',
          link: `/tickets/${ticket._id}`,
        },
      ];
    },

    hasMessages(ticket) {
      try {
        return ticket.internal_messages.length > 0;
      } catch (e) {
        return false;
      }
    },

    hasCommunication(ticket) {
      try {
        return ticket.communication.length > 0;
      } catch (e) {
        return false;
      }
    },

    sendNewInternalMessage() {
    },

    handleFileUpload() {
      this.newInternalMessage.files = this.$refs.internalMessageFile.files;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/tickets/SingleTicket.vue